const SUCCESS = (value) => ({ success: true, value });
export default SUCCESS;
